<template>
	<div>
		<form class="account_ajax account__form" @submit.prevent="sendReg">
			<transition name="fade">
				<div class="account__errors" v-if="errors">{{ errors }}</div>
			</transition>
			<label class="uk-form-label">
				<span>Ваш Email</span>
				<input class="uk-input" name="email" type="email" placeholder="Email">
			</label>
			<label class="uk-form-label">
				<span>Пароль</span>
				<input class="uk-input" name="password" type="password" placeholder="Пароль">
			</label>
			<div class="account__buttons">
				<button class="uk-button uk-button-primary" type="submit" :disabled="!$root.confid">Войти на сайт</button>
				<div class="confid">
					<label>
						<input type="checkbox" class="uk-checkbox" v-model="$root.confid" />
						<div class="confid__content">
							<span>Я согласен с</span><a uk-toggle="target: #politicamodal">политикой конфиденциальности</a></div>
					</label>
				</div>
			</div>
		</form>
		<div class="account__bottom">
			<div class="account__podp">
				У вас нет аккаунта? <a class="uk-button uk-button-text" :href="url + '/register'">Зарегистрируйтесь</a>
			</div>
		</div>
	</div>
</template>

<script>
  import { account } from "../mixins/account";

  export default {
    name: "account-login",
    mixins: [account],
    data() {
      return {}
    },
    props: {
      items: ''
    },
    methods: {
      sendReg() {
        let app = this;
        $('.account_ajax').request('Login::onAjax', {
          //data: {'email': $('input[name="email"]').val()},
          success: function (data) {
            //console.log(data);
            app.checkErrors(data);
            //console.log(data);
            /*if(data.status) {
              //Email is available
            } else {
              //Email is not available
            }*/
          }
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/account-login.vue